<section class="hero is-success is-small">
  <div class="hero-body">
    <div class="container">
      <h1 class="title">
        <span class="icon-text">
          <span class="icon"><i class="fa-solid fa-paw" aria-hidden="true"></i></span>
          <span data-category-title></span>
        </span>
      </h1>
    </div>
  </div>
</section>

<section class="section container">
  <div class="grid two">
    <div>
      <h2>Quick Reference</h2>
      <div class="table-wrap"><table class="table is-striped is-fullwidth">
        <tr><th>Canonical ID</th><td data-category-label></td></tr>
        <tr><th>Morphisms</th><td data-category-morphisms></td></tr>
        <tr><th>Objects</th><td data-category-objects></td></tr>
        <tr><th>Index</th><td data-category-index></td></tr>
        <tr><th>Name</th><td data-category-name></td></tr>
        <tr><th>Description</th><td data-category-description></td></tr>
      </table></div>
    </div>
    <div>
      <h2>Visualization</h2>
      <div data-category-visualization></div>
    </div>
  </div>
</section>

<section class="section container">
  <div class="grid two">
    <div><h2>Table</h2><div data-category-table></div></div>
    <div><h2>Facts</h2><div data-category-facts></div></div>
  </div>
</section>
